// Platform values - must match backend enum values
export const PLATFORMS = {
  WORDPRESS: 'WORDPRESS',
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  MAILCHIMP: 'MAILCHIMP',
  WEBFLOW: 'WEBFLOW',
  WEBSITE: 'WEBSITE',
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
  GOOGLE: 'GOOGLE',
  EMAIL: 'EMAIL'
};

export const PLATFORM_LABELS = {
  [PLATFORMS.WORDPRESS]: 'WordPress',
  [PLATFORMS.FACEBOOK]: 'Facebook',
  [PLATFORMS.INSTAGRAM]: 'Instagram',
  [PLATFORMS.MAILCHIMP]: 'Mailchimp',
  [PLATFORMS.WEBFLOW]: 'Webflow',
  [PLATFORMS.WEBSITE]: 'Website',
  [PLATFORMS.SOCIAL_MEDIA]: 'Social Media',
  [PLATFORMS.GOOGLE]: 'Google',
  [PLATFORMS.EMAIL]: 'Email'
};


export const PUBLISH_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  FAILED: 'FAILED',
  SCHEDULED: 'SCHEDULED'
};

const PUBLISH_STATUS_LABELS = {
  [PUBLISH_STATUS.DRAFT]: 'Draft',
  [PUBLISH_STATUS.PUBLISHED]: 'Published',
  [PUBLISH_STATUS.FAILED]: 'Failed',
  [PUBLISH_STATUS.SCHEDULED]: 'Scheduled'
};


// Platform icons (using Material-UI icon names)


export const getPlatformLabel = (platformValue) => {
  return PLATFORM_LABELS[platformValue] || platformValue;
};

export const getPublishingStatusLabel = (statusValue) => {
  return PUBLISH_STATUS_LABELS[statusValue] || statusValue || 'Not Published';
};